import { HookError } from 'components/ErrorBoundary';
import { useContext } from 'react';
import { AuthenticationContext } from './context';
import { AuthenticationContextType } from './types';

export const useAuthentication = (c = AuthenticationContext): AuthenticationContextType => {
  const context = useContext(c);

  if (context === undefined) {
    throw new HookError(`${useAuthentication.name} must be used within a Provider.`);
  }
  return context;
};
